import type { PathConfig } from '@react-navigation/native';
import type { Parameters } from './navigator';

// Legacy /chat links must resolve inside the native tab navigator, too.
export function getNativeChatPath(path: string) {
  return path.replace(/^\/chat(?=\/|\?|#|$)/, '/main/chat');
}

export const linking: PathConfig<Parameters> = {
  path: '/chat',
  initialRouteName: 'all-channels',
  screens: {
    'all-channels': '/all',
    'new-conversation': '/new-conversation',
    'new-group-chat': '/new-group-chat',
    'chat-members': '/:url/members',
    'add-chat-members': '/:url/add-members',
    'one-channel': '/:url',
    'loan-dates-picker': '/:url/dates',
    'listing-bonification': '/bonification/:bonificationId',
  },
};
